export default Object.freeze({
  Twilio: 1,
  Sendblue: 2,
});
